<div class="rv-flex flex-column flex-nowrap container">
  <div class="rv-flex flex-column flex-center rv-flex-grow-auto main">
    <img class="logo" [attr.src]="logoUrl" />

    <div class="rv-card surface-0 content">
      <loadable [data]="loadableData_">
        <div class="rv-grid large outer" [class.outer-xlarge]="xlarge">
          <ng-content></ng-content>
        </div>
        <ng-content select="footer"></ng-content>
      </loadable>
    </div>
    <div
      *ngIf="includeLanguageChange"
      class="rv-link language"
      (click)="changeLang()"
    >
      {{ 'patientEstimate.clickToViewInLanguage' | translate }}
    </div>
  </div>
  <div class="powered">
    <logo [size]="32" [compact]="true"></logo>
    <span>{{ 'patientEstimate.poweredByRivet' | translate }}</span>
  </div>
</div>
